import gql from 'graphql-tag'

const GC_GET_ASSET_LIST = gql`
query GetMediaList {
    media {
      id
      name
      path
      thumbnail_path
      type:mediaType{
        name
        id
        slug
      }
    }
  }
`

const GC_GET_MEDIA_LIBRARY_LIST = gql`
query GetMediaList($location_slugs: [String!]!, $type_slugs: [String!]!) {
  location(where: {slug: {_in: $location_slugs}}) {
    name
    scenarioLocations(where: {scenario: {scenarioType: {slug: {_eq: "scenario"}}}}) {
      scenario {
        id
        name
        nodes(order_by: {title: asc}, where: {nodeType: {slug: {_in: $type_slugs}}, title: {_neq: ""}}) {
          title
          node_content
          type: nodeType {
            slug
          }
        }
      }
    }
  }
}
`

export {
  GC_GET_ASSET_LIST,
  GC_GET_MEDIA_LIBRARY_LIST
}